const IS_TILT = window.location.hostname.includes('local.cast.ai');
const debugTrial =
  new URLSearchParams(window.location.search).get('debug_trial') === 'true';

export const TRIAL_ENABLED = !IS_TILT || debugTrial;
